import { render, staticRenderFns } from "./InvestmentIndex.vue?vue&type=template&id=6722d682&scoped=true&"
import script from "./InvestmentIndex.vue?vue&type=script&lang=js&"
export * from "./InvestmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentIndex.vue?vue&type=style&index=0&id=6722d682&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722d682",
  null
  
)

export default component.exports